
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/manufacturing/page/[id]",
      function () {
        return require("private-next-pages/cases/manufacturing/page/[id].tsx");
      }
    ]);
  